import React from 'react';
import {ReactTabulatorJsHotel} from '../Tabulator/TabulatorHotel'
import { Form } from 'react-bootstrap'

const CabinetUserHotel = () => {

    return (
        <>
          <br></br>
          <div style={{textAlign: "center"}}><h2>Гостиница</h2></div>
          <hr></hr>
          <Form className="d-flex justify-content-end">
          
          </Form>
          <ReactTabulatorJsHotel/>
        </>
    );
};

export default CabinetUserHotel;